import {get, post, postFile} from '../request/request.js'

// 手机号验证码登录
export function codeLogin(data) {
	return post('api/login/code_login', data)
}

// 账号密码登录
export function pwdLogin(data) {
	return post('api/login/passwordLogin', data)
}

// 注册
export function register(data) {
	return post('api/login/phoneRegister', data)
}

// 根据手机号获取验证码
export function getPhoneCode(data) {
    return post('api/login/get_code', data)
}

// 查看用户协议
export function getAgreement(data) {
    return post('api/Agreement/getAgreement', data)
}

// 查看隐私协议
export function getCancelAgreement(data) {
    return post('api/Agreement/getCancelAgreement', data)
}

// 首页轮播图
export function getIndexBannerList(data) {
    return post('api/banner/getPcBanner', data)
}

// 首页雪场列表
export function getIndexWebsiteList(data) {
    return post('api/Website/index', data)
}

// 首页商品列表
export function getIndexCommodityList(data) {
    return post('api/Website/lists', data)
}

// 首页底部雪场列表
export function getIndexFieldList(data) {
    return post('api/goods/getFieldList', data)
}

// 日历价格
export function getGoodsPrice(data) {
    return post('api/goods/goodsPrice', data)
}

// 商品详情
export function getGoodsDetail(data) {
    return post('api/goods/getInfo', data)
}

// 雪场详情
export function getSkiResortInfo(data) {
    return post('api/field/getOne', data)
}

// 公司详情介绍
export function getAboutUsInfo(data) {
    return post('api/Agreement/getCompanyIntroduction', data)
}

// 商家入驻
export function merchantSettlement(data) {
    return post('api/Website/settled', data)
}

// 身份证上传
export function idCardUpload(data) {
	return post('api/Upload/uploadImg', data)
}

// 雪场信息
export function getSkiResortDeail(data) {
	return post('api/instructor/fieldDetail', data)
}

// 订单列表
export function getOrderList(data) {
	return post('api/order/list', data)
}

// 提交订单
export function placePayOrder(data) {
	return post('api/Website/wxJsapi', data)
}

// 查询订单支付状态
export function paymentStatus(data) {
	return post('api/Website/wxOrderquery', data)
}



// WEBPACK FOOTER //
// ./src/request/api.js